const menuHTML = `
  <div class="seperated left">
    <ul class="navbar">
      <li class="width-30"><a>Export to XLSX</a></li>
      <li class="width-15"><a>Open</a></li>
      <li class="width-15"><a>New</a></li>
      <li class="width-30"><a>Assemblies</a></li>
      <li class="width-10"><a>+</a></li>
    </ul>
  </div>
  <div class="seperated right">
    <div class="seperated labour">
      <div class="first">
        <p>Labour (all)</p>
      </div>
      <div class="second">
        <ul class="navbar">
          <li class="width-50"><a>Office based</a></li>
          <li class="width-50"><a>Workshop</a></li>
        </ul>
      </div>
    </div>
    <div class="seperated procurement">
        <div class="first">
          <p>Procurement (all)</p>
        </div>
        <div class="second">
          <ul class="navbar">
            <li class="width-20"><a>Sections</a></li>
            <li class="width-20"><a>Fittings</a></li>
            <li class="width-20"><a>Fasteners</a></li>
            <li class="width-20"><a>Surface</a></li>
            <li class="width-20"><a>Transport</a></li>
          </ul>
        </div>
    </div>
`;

const menuWrap = document.querySelector('.header');
menuWrap.innerHTML = menuHTML;
